import React, { Component } from 'react';
import Helmet from 'react-helmet';
import './refer.scss';

class Log4JPage extends Component {
    render() {
        return (
            <div className='referral-container'>
                <Helmet title={`Datasert - Realfire and Log4j2 Vulnerability`} />

                <div className='content'>
                    <h2>
                        Realfire and Log4j2 Vulnerability
                    </h2>
                    <p><strong>TLDR: Realfire is NOT impacted by the vulnerability</strong></p>
                    <p>One of the sub-component of the Realfire uses log4j Version 1 which is <a href="https://logging.apache.org/log4j/2.x/security.html">not impacted</a>  by this vulnerability hence no action is required to be taken at this time</p>
                    <p>
                        <a href="https://gist.github.com/brsanthu/2e649716653f1be8dac440fb65c5653a">Here</a> is complete list of files included in the Realfire v5.3.2 (our latest version).
                    </p>
                    <p>If you have any questions, please reach out to us at support@datasert.com</p>
                </div>
            </div>
        );
    }
}

export default Log4JPage;


// WEBPACK FOOTER //
// ./src/pages/products/realfire/log4j2.jsx